/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

// Set true for app localized.
const defaultLocale = 'en';
const locales = ['en'];

// The format map provides an ability to separate locales from the format of dates.
// An important note is that messages is the language that will be sent to the backend as the language to get data
// LocaleFormat is what will be configured in react-intl for number and date formats.
// The messages (texts in the website) will be based on messages information, so if the user visits in this case "en"
// he would see number formatted in "en" (but it could be configured for de or pt).
// Each of the keys in the mapping will be sent to nextJs as the allowed locale.
// const formatMap = {
//   [defaultLocale]: {
//     messages: defaultLocale,
//     localeFormat: defaultRegion,
//   },
// };
const formatMap = {};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    TURBOPACK_BUILD: true,
    LOCALES: locales,
    DEFAULT_LOCALE: defaultLocale,
    FORMAT_MAP: formatMap,
    SITENAME: 'Cause Jobs',
    SITE_DESCRIPTION: 'Charities, nonprofits, churches, Christian ministries, post your jobs here. Apply and submit your resume for charity, Christian organization jobs and careers.',
    FRONTENDS: {
     default: 'missionaljobs',
    },
    THEME: {
      colors: {
        primary: '#f49708',
      },
    },
    FONTS: {
      OPTIMIZED: true,
    },
    PRICE_CONFIG: {
      CURRENCY_PLACEMENT: 'before',
      USE_SPACING: true,
    },
    SOCIAL_LINKS: {
      linkedin: 'https://www.linkedin.com/company/causeleadershipinc/',
      youtube: 'https://www.youtube.com/@causeleadership',
    },
    GA4_MEASUREMENT_IDS: ['G-TF0KNQTRNT'],
    GOOGLE_MEASUREMENT_API_ENABLED: true,
    BLOG_FEATURE_ACTIVE: true,
  },
});
